// Función que crea el estilo de la parcela en general
export const styleParcelas = context => {
  const finded = context.parcelasParaComparar.find(
    (x: any) => x === context.feature.properties.ref_cat
  );
  // console.log(this.lyrParcelasComunero.getLayers().find(layer => {console.log(layer.feature.properties.ref_catastral == feature.properties.ref_cat)}));

  return finded
    ? {
        fillColor: 'white',
        color: 'white',
        weight: 1.5,
        opacity: 0.0,
      }
    : {
        fillColor: '#12ff01',
        color: 'white',
        weight: 1.5,
        opacity: 0.6,
      };
};

// Función que da estilo a la parcela segun el hidrante
export const styleParcelaXHidrante = feature => {
  return {
    //fillColor: 'rgba(186, 93, 0, 0.5)',
    fillColor: 'rgba(223, 123, 0, 0.5)',
    fillOpacity: 1,
    color: 'white',
    weight: 2,
    opacity: 0.7,
  };
};
